import httpClient from "../utils/httpClient";

export const BlogData = async (requestParams) => {
    const response = await httpClient.post(`/Blog/blogs`, requestParams);
    return response.data;
};

export const BlogDetail = async (slug) => {
    // GET request with slug in the URL
    const response = await httpClient.get(`/Blog/blogs/${slug}`);
    return response.data;

};

export const GetTrendyBlog = async () => {
    const response = await httpClient.post(`/Blog/blogs-trendy`, {});
    return response.data;

};
